




































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {SelectBox, SelectMarket, TaskInfoCalc} from '@/interfaces/global-data';
import {
    GetTaskInfo,
    PreCalcColumns,
    PreCalcFilters,
    PreCalcIndividualConfigs,
    SmallPreCalcListFilter,
    TaskData,
    TaskInfoFilterType,
    UserRole,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import {FormatNumber} from '@/numberFormatter';
import moment from 'moment';
import {Component, Mixins, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';

@Component({
    components: {
        MarketSelect,
        MultiSelect,
        vSelect,
        DatePicker,
        CollapseCard,
        Card,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY HH:mm:ss');
            }
        },
    },
    methods: {
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
    },
})
export default class Precalculations extends Mixins(LocalData, Toast, Http) {
    // tslint:disable-next-line: ban-types
    onDropdownClosed: Function | null = null;
    dropDownOpen = false;
    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectTradingFilter: number = this.defaultFilterValue.value;
    traidingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: SelectBox<number> = this.defaultFilterValue;
    newSelectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];
    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('regular.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('regular.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('regular.common.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('regular.common.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('regular.common.all') as string}],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    searchable: boolean = true;

    preCalcTableRows: any[] = [];

    newPreCalcTableFields: any[] = [
        {dataIndex: 'id', title: this.$t('regular.columns.actions') as string, scopedSlots: { customRender: 'options' }, fixed: 'left', width: 160},
        {dataIndex: 'statusMessage', title: this.$t('regular.columns.status') as string, width: 150, ellipsis: true, customRender: (_: string, item: any) => item.status ? localizeTaskStatus(item.status) : _},
        {dataIndex: 'updated', title: this.$t('regular.columns.changeTime') as string, width: 250, ellipsis: true},
        {dataIndex: 'tradingName', title: this.$t('regular.columns.company') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'tradingFilter', filterIcon: "tradingFilterIcon" }, ellipsis: true},
        {dataIndex: 'groupOfProduct', title: this.$t('regular.columns.group') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'groupOfProductFilter', filterIcon: "groupOfProductFilterIcon" }, ellipsis: true},
        {dataIndex: 'category', title: this.$t('regular.columns.category') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, ellipsis: true},
        {dataIndex: 'subcategories', title: this.$t('regular.columns.subcategory') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeFormat', title: this.$t('regular.columns.format') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeRegionValues', title: this.$t('regular.columns.region') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeRegionValuesFilter', filterIcon: "storeRegionValuesFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeCluster', title: this.$t('regular.columns.cluster') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon" }, ellipsis: true},
        {dataIndex: 'calculationDepth', title: this.$t('regular.columns.calcDepth') as string, width: 100, scopedSlots: { customRender: 'calculationDepth' }},
        {dataIndex: 'calculationDay', title: this.$t('regular.columns.forecastPeriod') as string, width: 100, scopedSlots: { customRender: 'calculationDay' }},
        {dataIndex: 'depthToPurchasePrice', title: this.$t('regular.columns.purchasePriceCalcDepth') as string, width: 100, scopedSlots: { customRender: 'depthToPurchasePrice' }},
        {dataIndex: 'calculateActual', title: this.$t('regular.statuses.actualCalc') as string, width: 130, scopedSlots: { customRender: 'calculateActual' }},
        {dataIndex: 'calculateComparable', title: this.$t('regular.statuses.compCalc') as string, width: 130, scopedSlots: { customRender: 'calculateComparable' }},
        {dataIndex: 'calculateAverage', title: this.$t('regular.statuses.avgCalc') as string, width: 130, scopedSlots: { customRender: 'calculateAverage' }},
        {dataIndex: 'calculatePurchasePrice', title: this.$t('regular.statuses.purchasePriceCalc') as string, width: 130, scopedSlots: { customRender: 'calculatePurchasePrice' }},
        {dataIndex: 'calculateRegularPrice', title: this.$t('regular.statuses.regularPriceCalc') as string, width: 130, scopedSlots: { customRender: 'calculateRegularPrice' }},
        {dataIndex: 'calculateCoeffElasticity', title: this.$t('regular.statuses.elasticityCalc') as string, width: 130, scopedSlots: { customRender: 'calculateCoeffElasticity' }},
        {dataIndex: 'calculateSegment', title: this.$t('regular.statuses.segmentCalc') as string, width: 130, scopedSlots: { customRender: 'calculateSegment' }},
    ];
    pagination: any = {
        pageSize: 20,
    };

    preCalcCurrentPage: number = 1;
    preCalcTotalRows: number = 0;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    private needLoadFiltersForTable: boolean = true;
    private preCalcLimit: number = 20;
    private refreshPreCalcListId = -1;
    numberFormatter = (v: any): string => FormatNumber.format(v);

    mounted() {
        if (this.$preCalc.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.updateSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
            (this.$refs.productSegmentsRef as any).toggleLoading(true);
            this.getCategoryInfo();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsGroup();
            self.loadProductsSubcategories();
            self.loadProductSegments();
        }

        EventBus.$on('calc', this.onCalcEventReceived);

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.handleFilter();
    }

    beforeDestroy() {
        EventBus.$off('calc', this.onCalcEventReceived);
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }

    }

    handleFilter() {
        this.fetchPreCalcList({
            currentPage: this.pagination.current
        }, () => {});
    }

    handleClearFilters() {
        this.newSelectTradingFilter = this.defaultFilterValue.value;
        this.newSelectCategoryFilter = this.defaultFilterValue.value;
        this.categoryFilterOptions = []
        this.newSelectGroupFilter = this.defaultFilterValue.value;
        this.groupFilterOptions = []
        this.newSelectSubcategoryFilter = this.defaultFilterValue.value;
        this.subcategoryFilterOptions = []
        this.newSelectFormatFilter = this.defaultFilterValue.value;
        this.formatFilterOptions = []
        this.newSelectRegionFilter = this.defaultFilterValue.value;
        this.regionFilterOptions = []
        this.newSelectClusterFilter = this.defaultFilterValue.value;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;

        this.handleFilter()
    }

    onPreCalcTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchPreCalcList({
            currentPage: pagination.current
        }, () => {});
    }

    refreshPreCalcReports() {
        const oldRefreshId = this.refreshPreCalcListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshPreCalcListId === timeoutId) {
                this.preCalcCurrentPage = 1;
                const preCalcValue = this.$refs.preCalcTableRef as any;
                if (typeof preCalcValue !== 'undefined') {
                    preCalcValue.refresh();
                }
                this.refreshPreCalcListId = -1;
            }
        }, 250);
        this.refreshPreCalcListId = timeoutId;
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$preCalc.categoryOfProduct = null;
                this.$preCalc.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.formatSelected = null;
                this.$preCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.clusterSelected = null;
                this.$preCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfo.categoryOptions = [{ value: null, label: this.$t('regular.misc.selectCategory') as string }];
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{ value: null, label: this.$t('regular.common.all') as string }];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{ value: null, label: this.$t('regular.common.selectCluster') as string }];
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.category:
                this.$preCalc.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.formatSelected = null;
                this.$preCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.clusterSelected = null;
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{ value: null, label: this.$t('regular.common.all') as string }];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{ value: null, label: this.$t('regular.common.selectCluster') as string }];
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.$preCalc.formatSelected = null;
                this.$preCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.$preCalc.clusterSelected = null;
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{ value: null, label: this.$t('regular.common.all') as string }];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{ value: null, label: this.$t('regular.common.selectCluster') as string }];
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$preCalc.formatSelected = null;
                this.$preCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$preCalc.clusterSelected = null;
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.$preCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$preCalc.clusterSelected = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegments();
                this.getRegionInfo();
                this.getClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.$preCalc.clusterSelected = null;
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegments();
                this.getClusterInfo();
                break;
        }
    }

    updateProductGroup(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$preCalc.groupOfProduct) {
            this.$preCalc.groupOfProduct = groupOfProduct;
            this.savePreCalc();
            this.resetData(TaskInfoFilterType.group);
        }
    }

    updateProductCategory(category: number | null) {
        if (category !== this.$preCalc.categoryOfProduct) {
            this.$preCalc.categoryOfProduct = category;
            this.resetData(TaskInfoFilterType.category);
            this.savePreCalc();
        }
    }

    updateFormat(format: number | null) {
        if (format !== this.$preCalc.formatSelected) {
            this.$preCalc.formatSelected = format;
            this.resetData(TaskInfoFilterType.format);
            this.savePreCalc();
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$preCalc.regionSelected)) {
            this.$preCalc.regionSelected = list;
            this.onDropdownClosed = () => {
                this.savePreCalc();
                this.resetData(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$preCalc.regionSelected[0] === 0) {
            this.$preCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateCluster(cluster: number | null) {
        if (cluster !== this.$preCalc.clusterSelected) {
            this.$preCalc.clusterSelected = cluster;
            this.resetData(TaskInfoFilterType.cluster);
            this.savePreCalc();
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$preCalc.buyerSegmentsList)) {
            this.$preCalc.buyerSegmentsList = list;
            this.savePreCalc();
        } else if (this.$preCalc.buyerSegmentsList[0] === 0) {
            this.$preCalc.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$preCalc.subcategories)) {
            this.$preCalc.subcategories = list;
            this.onDropdownClosed = () => {
                this.savePreCalc();
                this.resetData(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$preCalc.subcategories[0] === 0) {
            this.$preCalc.subcategories = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    updateProductSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$preCalc.productSegments)) {
            this.$preCalc.productSegments = list;
            this.onDropdownClosed = () => {
                this.savePreCalc();
                this.resetData(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$preCalc.productSegments[0] === 0) {
            this.$preCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    updateSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$preCalc.seasonSelected)) {
            this.$preCalc.seasonSelected = list;
            this.onDropdownClosed = () => {
                this.savePreCalc();
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$preCalc.seasonSelected[0] === 0) {
            this.$preCalc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSelectMarket(market: SelectMarket) {
        if (this.$preCalc.selectMarket == null || this.$preCalc.selectMarket.id !== market.id) {
            this.resetPreCalcData();
            this.$preCalc.selectMarket = market;
            this.initTask();
            this.savePreCalc();
        }
    }

    @Watch('newSelectTradingFilter')
    updateFilterTableSelectMarket() {
        this.clearPreCalcFilters(false);
        if (LocalData.zeroToNull(this.newSelectTradingFilter) != null) {
            this.httpGetAllFiltersInPreCalcReports(this.newSelectTradingFilter)
                    .then((response) => {
                                const result = response.data
                                const categories = result.categories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.categoryFilterOptions = categories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const groups = result.groupsOfProducts.filter((i) => {
                                    return i.name !== '';
                                });
                                this.groupFilterOptions = groups.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const subcategories = result.subcategories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.subcategoryFilterOptions = subcategories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const storeFormat = result.storeFormats.filter((i) => {
                                    return i.name !== '';
                                });
                                this.formatFilterOptions = storeFormat.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const regions = result.storeRegionValues.filter((i) => {
                                    return i.name !== '';
                                });
                                this.regionFilterOptions = regions.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const clusters = result.storeClusters.filter((i) => {
                                    return i.name !== '';
                                });
                                this.clusterFilterOptions = clusters.map((i) => {
                                    return {value: i.id, label: i.name};
                                });

                                this.newPreCalcTableFields[4].filters = [...this.groupFilterOptions];
                                this.newPreCalcTableFields[5].filters = [...this.categoryFilterOptions];
                                this.newPreCalcTableFields[6].filters = [...this.subcategoryFilterOptions];
                                this.newPreCalcTableFields[7].filters = [...this.formatFilterOptions];
                                this.newPreCalcTableFields[8].filters = [...this.regionFilterOptions];
                                this.newPreCalcTableFields[9].filters = [...this.clusterFilterOptions];

                                this.traidingsFilterOptions.unshift(this.defaultFilterValue);
                                this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                this.groupFilterOptions.unshift(this.defaultFilterValue);
                                this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                this.formatFilterOptions.unshift(this.defaultFilterValue);
                                this.regionFilterOptions.unshift(this.defaultFilterValue);
                                this.clusterFilterOptions.unshift(this.defaultFilterValue);

                                this.needLoadFiltersForTable = false;
                            },
                    )
                    .catch((ex) => {
                        this.showError(this.$t('regular.errors.loadPrecalcFiltersFailed') as string);
                    });
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
                || status === 'EmptyData'
                || status === 'ExecutionException'
                || status.includes('Error'));
    }

    selectData(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$preCalc.seasonSelected.length === 0 || (this.$preCalc.seasonSelected.length === 1 && this.$preCalc.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$preCalc.seasonSelected)!!;
        const selectRegions: number[] = (this.$preCalc.regionSelected.length === 0 || (this.$preCalc.regionSelected.length && this.$preCalc.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$preCalc.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$preCalc.buyerSegmentsList.length === 0 || (this.$preCalc.buyerSegmentsList.length && this.$preCalc.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$preCalc.buyerSegmentsList)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    initTask() {
        if (this.$preCalc.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.groupSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        (this.$refs.groupOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);

        this.$preCalc.categoryOfProduct = null;
        this.$preCalc.clusterSelected = null;
        this.$preCalc.formatSelected = null;
        this.$preCalc.groupOfProduct = null;
        this.$preCalc.subcategories = [];
        this.$preCalc.productSegments = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        const self = this;
        this.getCategoryInfo(() => {
            self.loadProductsGroup();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsSubcategories();
            self.loadProductSegments();
        });
    }

    loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupOfProductRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.groups.length > 0) {
                        this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.groupsOfProduct.unshift({value: null, label: this.$t('regular.common.all') as string});
                    } else {
                        this.$preCalc.groupOfProduct = null;
                        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
                    }
                })
                .catch((e) => {
                })
    }

    loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.subcategoriesRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
                })
                .catch((e) => {
                })
    }

    getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.groupSelectedRef as any).toggleLoading(false);
                        (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                    }, 250);
                    if (filterData.categories.length > 0) {
                        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.categoryOptions.unshift({value: null, label: this.$t('regular.common.selectCategory') as string});
                    } else {
                        this.$preCalc.categoryOfProduct = null;
                        this.taskInfo.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                        this.resetData(TaskInfoFilterType.category);
                    }
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                    this.taskInfo.storeFormatOptions = [{
                        value: null,
                        label: this.$t('regular.common.all') as string,
                    }, ...this.taskInfo.storeFormatOptions];

                })
                .catch((e) => {
                });
    }

    getBuyerSegment() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                })

    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                    this.taskInfo.clusterOptions = [{
                        value: null,
                        label: this.$t('regular.common.all') as string,
                    }, ...this.taskInfo.clusterOptions];

                })
                .catch((e) => {
                });
    }

    loadProductSegments() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then(data => {
                    const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.psegemnts = filterData.psegments.map(i => {
                        return {
                            label: i.name,
                        value: i.id
                    };
                    });
                this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('regular.common.all') as string });
                })
            .catch(e => { });
    }

    saveEditablePreCalc(precalcItem: PreCalcColumns) {
        const config: PreCalcIndividualConfigs = {
            calculationDepth: precalcItem.calculationDepth,
            calculationDay: precalcItem.calculationDay,
            depthToPurchasePrice: precalcItem.depthToPurchasePrice,
            calculateComparable: precalcItem.calculateComparable,
            calculateActual: precalcItem.calculateActual,
            calculateAverage: precalcItem.calculateAverage,
            calculatePurchasePrice: precalcItem.calculatePurchasePrice,
            calculateRegularPrice: precalcItem.calculateRegularPrice,
            calculateCoeffElasticity: precalcItem.calculateCoeffElasticity,
            calculateSegment: precalcItem.calculateSegment,
        }
        this.httpSavePreCalcIndividual(config, precalcItem.id)
                .then((r) => {
                            this.showInfo(this.$t('regular.notifications.precalcIndivParamsSaved') as string);
                            this.refreshPreCalcReports()
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.savePrecalcIndivParamsFailed') as string);
                });
    }

    deletePreCalc(preCalcId: number) {
        this.httpDeletePreCalc(preCalcId)
                .then((r) => {
                            this.showInfo(this.$t('regular.notifications.precalcDeleted') as string);
                            this.needLoadFiltersForTable = true;
                            this.refreshPreCalcReports()
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.deletePrecalcFailed') as string);
                });
    }

    stopPreCalc(preCalcId: number) {
        this.httpStopPreCalc(preCalcId)
                .then((r) => {
                            this.showInfo(this.$t('regular.notifications.precalcStopped') as string);
                            this.refreshPreCalcReports()
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.stopPrecalcFailed') as string);
                });
    }

    clearPreCalcFilters(refresh: boolean) {
        this.selectTradingFilter = this.defaultFilterValue;
        this.selectCategoryFilter = this.defaultFilterValue;
        this.categoryFilterOptions = []
        this.selectGroupFilter = this.defaultFilterValue;
        this.groupFilterOptions = []
        this.selectSubcategoryFilter = this.defaultFilterValue;
        this.subcategoryFilterOptions = []
        this.selectFormatFilter = this.defaultFilterValue;
        this.formatFilterOptions = []
        this.selectRegionFilter = this.defaultFilterValue;
        this.regionFilterOptions = []
        this.selectClusterFilter = this.defaultFilterValue;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;
        if (refresh) {
            this.refreshPreCalcReports()
        }
    }

    saveNewPreCalc() {
        if (this.$preCalc.selectMarket.id <= 0) {
            this.showError(this.$t('regular.notifications.tradingCompanyNotSelected') as string);
            return;
        }
        const preCalcParams = this.getPreCalcFilter();
        this.httpSavePreCalc(preCalcParams)
                .then((response) => {
                            this.showInfo(this.$t('regular.notifications.precalcSaved') as string);
                            this.needLoadFiltersForTable = true;
                            this.refreshPreCalcReports();
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('regular.errors.savePrecalcFailed') as string);
                });
    }

    fetchPreCalcList(ctx: any, callback: (items: any[]) => void) {
        this.httpGetAllTradingsPreCalc()
                .then((response) => {
                            const result = response.data

                            this.traidingsFilterOptions = result.map((i) => {
                                return {value: i.id, label: i.name};
                            });
                            this.newPreCalcTableFields[3].filters = [...this.traidingsFilterOptions]
                        },
                )
                .catch((ex) => {
                    this.showError(this.$t('regular.errors.loadTradingCompaniesFailed') as string);
                });
        const smallFilter = this.getSmallPreCalcFilter()
        const offset = (ctx.currentPage - 1) * this.preCalcLimit;
        this.httpGetSavedPreCalcReports(smallFilter, this.preCalcLimit, offset)
                .then((r) => {
                            const pagination = { ...this.pagination };
                            pagination.total = r.data.totalElements;
                            this.pagination = pagination;
                            this.preCalcTableRows = r.data.content.map((item) => ({
                                ...item,
                                id: item.id,
                                key: item.id,
                                updated: new Date(item.updated).toLocaleString('fr-FR')
                            }));
                            this.preCalcTotalRows = r.data.totalElements;
                            callback(r.data.content);
                        },
                )
                .catch((e) => {
                    callback([]);
                });
    }
    individualCalculationDepthValidate(calcDepth: number, calcDay: number): boolean {
        return calcDepth * 7 >= calcDay;
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$preCalc.selectMarket.id,
            categories: this.$preCalc.categoryOfProduct == null || this.$preCalc.categoryOfProduct <= 0 ? null : [this.$preCalc.categoryOfProduct],
            groups: this.$preCalc.groupOfProduct == null || this.$preCalc.groupOfProduct <= 0 ? null : [this.$preCalc.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$preCalc.subcategories, true),
            segments: null,
            storeFormat: this.$preCalc.formatSelected == null || this.$preCalc.formatSelected <= 0 ? null : [this.$preCalc.formatSelected],
            storeCluster: this.$preCalc.clusterSelected == null || this.$preCalc.clusterSelected <= 0 ? null : [this.$preCalc.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getPreCalcFilter(): PreCalcFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        return {
            id: -1,
            category: this.$preCalc.categoryOfProduct,
            storeCluster: this.$preCalc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$preCalc.formatSelected,
            tradingId: this.$preCalc.selectMarket.id,
            calculationDepth: +this.$preCalc.calculationDepth,
            calculationDay: +this.$preCalc.calculationDay,
            groupOfProduct: this.$preCalc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$preCalc.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$preCalc.productSegments)!!,
            depthToPurchasePrice: this.$preCalc.depthToPurchasePrice,
            calculateActual: true,
            calculateAverage: true,
            calculateCoeffElasticity: true,
            calculateComparable: true,
            calculatePurchasePrice: true,
            calculateRegularPrice: true,
            calculateSegment: true,
        };
    }

    private getSmallPreCalcFilter(): SmallPreCalcListFilter {
        return {
            tradingId: this.newSelectTradingFilter,
            category: this.newSelectCategoryFilter,
            groupOfProduct: this.newSelectGroupFilter,
            subcategories: this.newSelectSubcategoryFilter,
            storeFormat: this.newSelectFormatFilter,
            storeRegionValues: this.newSelectRegionFilter,
            storeCluster: this.newSelectClusterFilter,
        };
    }

    get saveState(): boolean {
        return !((this.$preCalc.groupOfProduct != null && this.$preCalc.groupOfProduct > 0)
                || (this.$preCalc.categoryOfProduct != null && this.$preCalc.categoryOfProduct > 0))
    }

    get isAdmin(): boolean {
        return this.$userRole === UserRole.ROLE_ADMIN;
    }

    get calculationDayValidate(): boolean {
        return this.$preCalc.calculationDay > 0;
    }

    get isGroupSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$preCalc.groupOfProduct != null && this.$preCalc.groupOfProduct!! > 0;
    }

    get isCategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$preCalc.categoryOfProduct != null && this.$preCalc.categoryOfProduct!! > 0;
    }

    get isSubcategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$preCalc.subcategories != null && this.$preCalc.subcategories.length!! > 0;
    }

    get calculationDepthValidate(): boolean {
        return this.$preCalc.calculationDepth * 7 >= this.$preCalc.calculationDay;
    }

}
